import type { RegistryItems } from "@aviv-unified-frontend/registry";

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const REAL_ITEMS = require(
  `@aviv-unified-frontend/registry/${
    process.env.BRAND
  }/${process.env.ENVIRONMENT === "local" ? "dev" : process.env.ENVIRONMENT}`,
).REGISTRY_ITEMS as RegistryItems;
